import React, { Component } from 'react'
import { Dialog } from 'primereact/dialog';
import EmailConfig from './configuration/addEmailConfig';
import AddSMSConfig from './configuration/addSMSConfig';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import WhatsAppConfig from './configuration/whatsAppConfig';


export default class OrgConfiguration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTab: 1,
            editExamType: null,
            editExamId: null,
            editedExamType: null
            //   editQuestion: { "boardId": "498fc658-d02f-4fd1-9181-0fb3912a0046", "classId": "0d438539-a00d-4e7c-8d3e-fb69b5115ac7", "questionId": "quwcz6", "attachmentUrl": "2e7e2ed0-93c3-11ec-8b22-b9072e580be7-3bbf81e0-90a6-11ec-9952-0772e613770a-5cf25c00-9085-11ec-a023-99336dc287ba-3ab6ecb0-c61d-11eb-a156-dd39ba84a64d-24.JPG", "boardName": null, "chapterId": "2dd40f6d-ea93-4f94-aa3f-7469bfbe9e3f", "chapterName": "Some Basic Concepts in Chemistry", "className": "CLASS XI", "difficulty": "Easy", "examType": ["JEE Advanced"], "explainationAttachment": "", "explanation": "eere", "groupId": "f416478b-6f24-465f-9740-9088380cdfd5", "groupName": "NO_GROUP", "hint": "rerererrr", "hintAttachment": "", "key": "A", "language": [], "options": [{ "id": "A", "imageUrl": "32d776d0-93c3-11ec-8b22-b9072e580be7-a0525360-7eab-11ec-88f1-d11a2f94386b-007a2cd0-cb3a-11ea-a087-ebd9b58bc35d-DkKRlco_atNOEbdvYph6ykOiAUtLZ3EpXL_iduSDoAU.original.fullsize.png", "value": "ewrewrewrwer" }, { "id": "B", "imageUrl": "", "value": "ewrwerwerwer" }, { "id": "C", "imageUrl": "", "value": "ewrwerwerwe" }, { "id": "D", "imageUrl": "", "value": "erererer" }], "previousExam": [{ "id": "9167a690-c63f-4c90-9957-d1802c298ea7", "data": { "exam": "JEE Advanced", "year": 2021 }, "assigned": true }], "question": "Molal depression constant for water is $1.86 \\mathrm{k} \\mathrm{kg} \\mathrm{mol}^{-1}$ the freezing point of a $0.05 \\mathrm{molal}$ solution of a non-electrolyte in water is. From a tower of height $\mathrm{H},$ a particle is thrown vertically upwards with a speed u. The time taken by the particle, to hit the ground, is n times that taken by it to reach the highest point of its path", "questionTarget": "Normal", "questionType": "SCCT", "skillType": "Critical Thinking", "source": "Meluha", "status": "Created", "subjectId": "8ed4c470-c76a-44e1-a341-3727c2ce0193", "subjectName": "Chemistry", "tags": ["erer", "etr"], "topicId": "9493e8f6-d2a1-4380-b9d9-8026da4964ad", "topicName": "Laws of Chemical combinations & Dalton theory", "videoLinking": [], "createdAt": { "$date": "2022-02-22T09:39:19.652Z" }, "updatedAt": { "$date": "2022-02-22T09:39:19.652Z" }, "__v": 0 }
        }
    }

    changeTab = (tab) => {
        // if (this.state.editQuestion) {
        this.setState({
            selectedTab: tab,
            editedExamType: null,
            editExamType: null
        })
        // }

    }

    render() {
        const { selectedTab, } = this.state;
        return (


            <div className='card ma-paper pl-4'>
                <h4>{this.props.editOrganization.name} Configuration</h4>
                <div className="question-bank flex mt-3">
                    <div className='qb-tabs mt-2'>
                        <span onClick={() => { this.changeTab(1) }} className={selectedTab == 1 ? 'qb-active-tab' : 'qb-inactive-tab'}>Email Config</span>
                        <span onClick={() => { this.changeTab(2) }} className={selectedTab == 2 ? 'qb-active-tab' : 'qb-inactive-tab'}>SMS Config</span>
                        <span onClick={() => { this.changeTab(3) }} className={selectedTab == 3 ? 'qb-active-tab' : 'qb-inactive-tab'}>WhatsApp Config</span>
                    </div>
                </div>
                {
                    selectedTab == 1 && <EmailConfig orgId={this.props.orgId} />
                }
                {
                    selectedTab == 2 && <AddSMSConfig orgId={this.props.orgId} />
                }
                {
                    selectedTab == 3 && <WhatsAppConfig orgId={this.props.orgId} />
                }
                {/*

                    {
                        selectedTab == 2 && <Examslist editedExamType={editedExamType} onEditExam={this.onEditExam} />
                    }
                    {
                        selectedTab == 3 && <ExamResults />
                    }
                    {
                        selectedTab == 4 && <ExamTemplates />
                    } */}
                {/* <Toolbar className="ma-toolbard" */}
                    {/* right={() => { */}
                        {/* return  */}
                <div className='flex justify-content-end'>
                    <Button label="Cancel" className='p-button-outlined'
                        onClick={this.props.onClose} />
                </div>
                    {/* }} */}
                {/* /> */}
            </div>

        )
    }
}
